import { r as registerInstance, h, H as Host, g as getElement } from './index-662ec80e.js';
import { p as propCheck, r as runWatchers, h as hasPropError, d as displayPropError } from './propCheck-e7571e3e.js';
import { S as vOneOf, a as vString } from './validation-02b8d01d.js';
import { a as logoNames, l as logoAssets } from './types-1b657857.js';
import './i18n-939e2dee.js';
import './types-6f6b2fba.js';

const dsLogoCss = "ds-logo{display:-ms-inline-flexbox;display:inline-flex}";

const DsLogo = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.propError = {};
    this.name = undefined;
    this.width = 'auto';
    this.height = '1rem';
  }
  async watchName() {
    /* istanbul ignore if */
    if (!propCheck(this, 'name', logoNames.join(' | '), vOneOf(logoNames)))
      return;
  }
  async watchWidth() {
    /* istanbul ignore if */
    if (!propCheck(this, 'width', 'string', vString))
      return;
  }
  async watchHeight() {
    /* istanbul ignore if */
    if (!propCheck(this, 'height', 'string', vString))
      return;
  }
  getSVGFromAsset(asset) {
    return atob(asset.split(',', 2)[1]);
  }
  connectedCallback() {
    runWatchers(this);
  }
  componentDidRender() {
    const svg = this.hostElement.firstChild;
    if (svg.tagName !== 'svg')
      return; // something went wrong
    svg.style.width = this.width;
    svg.style.height = this.height;
  }
  render() {
    if (hasPropError(this))
      return displayPropError(this);
    return (h(Host, { innerHTML: this.getSVGFromAsset(logoAssets[this.name]) }));
  }
  static get assetsDirs() { return ["./assets"]; }
  get hostElement() { return getElement(this); }
  static get watchers() { return {
    "name": ["watchName"],
    "width": ["watchWidth"],
    "height": ["watchHeight"]
  }; }
};
DsLogo.style = dsLogoCss;

export { DsLogo as ds_logo };
